import { useState } from 'react';
import UserService from '../Services/UserService';
import type { PartialProfessionalProfileUpdate, UserRead } from '../../Types/schema-helpers';

export const useUserMeSkills = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  /**
   * Sends partial professional profile updates (specialty, subspecialty, skills)
   * to the backend via UserService.
   */
  const updateSkills = async (payload: PartialProfessionalProfileUpdate): Promise<UserRead> => {
    setLoading(true);
    setError(null);
    try {
      const updatedUser = await UserService.updateProInfoByPro(payload);
      return updatedUser;
    } catch (err: any) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateSkills,
    loading,
    error,
  };
};